var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"invoice-frequency"},[_c('span',{staticClass:"font-weight-bolder"},[_vm._t("invoice-price")],2),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }